import Api from './Api';

class _OrderApi extends Api {
    storeOrder(projectId: number): Promise<any> {
        return this.getLocalHttpClient().post(`projects/${projectId}/order`);
    }
}

export const OrderApi = new _OrderApi();
